import { Environment } from "./environment.interface";

export const environment: Environment = {
	production: false,
	brands: {
		enelx: {
			globalNavUrl: 'https://global-nav.preprd-svcs.enelx.net/api/v1',
			baseUrl: 'https://flex-home.preprd-apps.enelx.com/v1'
		}
	},
	cdn: 'https://cdn.dev-apps.enelx.net',
	defaults: {
		brand: 'enelx',
		locale: 'en-us',
		apiLocale: 'en_US'
	},
	externalUrls: {
		activeEvents: 'https://active-dispatches.preprd-apps.enelx.com',
		com: 'https://customer-offers.preprd-apps.enelx.com',
		trends: 'https://trends.preprd-apps.enelx.com',
	}
};
